import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HomePage } from "./pages/HomePage";
import CaleraDemo from "./components/CaleraDemo";
import TveDemo from "./components/TveDemo";

function App() {
  useEffect(() => {
    const { hostname, protocol, pathname, search } = window.location;

    // Redirigir a www si es dominio raíz
    if (hostname === "nexoiot.com") {
      window.location.replace(
        "https://www.nexoiot.com" + pathname + search
      );
      return;
    }

    // Forzar HTTPS
    if (protocol !== "https:") {
      window.location.replace(
        "https://" + hostname + pathname + search
      );
    }
  }, []);

  return (
    <div>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/calera-demo" element={<CaleraDemo />} />
        <Route path="/tve-demo" element={<TveDemo />} />
      </Routes>
    </div>
  );
}

export default App;
